export const StorageKey = {
    cache_favourite_reports: "cache_favourite_reports",
    cache_collapse_reports: "cache_collapse_reports",
    cache_custom_fields: "cache_custom_fields",

    sale_invoice: "sale_invoice",
    sale_credit_note: "sale_credit_note",
    sale_payment: "sale_payment",
    sale_refund: "sale_refund",
    sale_quote: "sale_quote",
    sale_order: "sale_order",
    sale_delivery_order: "sale_delivery_order",
    purchase_bill: "purchase_bill",
    purchase_credit_note: "purchase_credit_note",
    purchase_payment: "purchase_payment",
    purchase_refund: "purchase_refund",
    purchase_order: "purchase_order",
    purchase_goods_received_note: "purchase_goods_received_note",
    bank_income: "bank_income",
    bank_expense: "bank_expense",
    bank_transfer: "bank_transfer",
    bank_reconciliation_manual: "bank_reconciliation_manual",
    bank_reconciliation_smart: "bank_reconciliation_smart",
    bank_accounts: "bank_accounts",
    bank_feed_transaction: "bank_feed_transaction",
    product_items: "product_items",
    stock_adjustment: "stock_adjustment",
    stock_transfer: "stock_transfer",
    stock_values: "stock_values",
    journal_entry: "journal_entry",
    contra: "contra",
    tax_deemed_payment: "tax_deemed_payment",
    chart_accounts: "chart_accounts",
    contacts: "contacts",
    contact_group: "contact_group",
    contact_statement: "contact_statement",
    product_group: "product_group",
    instructions: "instructions",

    // ------- REPORTS ---------
    // financial reports
    report_balance_sheet: "report_balance_sheet",
    report_profit_loss: "report_profit_loss",
    report_cash_flow: "report_cash_flow",
    report_financial_summary: "report_financial_summary",

    // aging reports
    report_aging_summary_receivable: "report_aging_summary_receivable",
    report_aging_summary_payable: "report_aging_summary_payable",
    report_aging_details_receivable: "report_aging_details_receivable",
    report_aging_details_payable: "report_aging_details_payable",

    // sales reports
    report_invoice_summary: "report_invoice_summary",
    report_sale_credit_note_summary: "report_sale_credit_note_summary",
    report_payment_summary: "report_payment_summary",
    report_quotation_by_customer: "report_quotation_by_customer",
    report_sale_order_by_customer: "report_sale_order_by_customer",
    report_delivery_order_by_customer: "report_delivery_order_by_customer",
    report_sales_by_customer: "report_sales_by_customer",
    report_sales_by_tag: "report_sales_by_tag",

    // purchase reports
    report_bill_summary: "report_bill_summary",
    report_purchase_payment_summary: "report_purchase_payment_summary",
    report_purchase_credit_note_summary: "report_purchase_credit_note_summary",
    report_purchases_by_supplier: "report_purchases_by_supplier",
    report_purchase_order_by_supplier: "report_purchase_order_by_supplier",

    // Payment reports
    report_payment_voucher_summary: "report_payment_voucher_summary",
    report_official_receipt_summary: "report_official_receipt_summary",
    report_cash_sales_summary: "report_cash_sales_summary",
    report_cash_purchase_summary: "report_cash_purchase_summary",

    // product reports
    report_product_sales_summary: "report_product_sales_summary",
    report_product_sales_detail: "report_product_sales_detail",
    report_product_bundle_sales_summary: "report_product_bundle_sales_summary",
    report_product_purchases_summary: "report_product_purchases_summary",
    report_product_purchases_detail: "report_product_purchases_detail",
    report_item_sales_collection: "report_item_sales_collection",

    // Inventory reports
    report_inventory_summary: "report_inventory_summary",
    report_inventory_detail: "report_inventory_detail",
    report_inventory_summary_by_location: "report_inventory_summary_by_location",
    report_profit_summary: "report_profit_summary",
    report_profit_detail: "report_profit_detail",

    // Fixed Asset Reports
    report_fixed_assets: "report_fixed_assets",
    report_depreciation: "report_depreciation",
    report_disposal: "report_disposal",

    // Ledger Reports
    report_general_ledger: "report_general_ledger",
    report_debtor_ledger: "report_debtor_ledger",
    report_creditor_ledger: "report_creditor_ledger",

    // SST Reports
    report_sst_02: "report_sst_02",
    report_sst_sales_detail: "report_sst_sales_detail",
    report_sst_purchase_detail: "report_sst_purchase_detail",
    report_sst_payment_collection: "report_sst_payment_collection",
    report_sst_deemed_payments: "report_sst_deemed_payments",
    report_sst_recovered_payments: "report_sst_recovered_payments",
    report_sst_past_prepayments: "report_sst_past_prepayments",
    report_sst_current_prepayments: "report_sst_current_prepayments",
    report_sst_by_products: "report_sst_by_products",

    // Accounting Reports
    report_journal_entry_detail: "report_journal_entry_detail",
    report_double_entry_detail: "report_double_entry_detail",
    report_trial_balance: "report_trial_balance",
    report_bank_reconciliation: "report_bank_reconciliation",
    report_reconciled_transactions: "report_reconciled_transactions",
    report_transaction_list: "report_transaction_list",
    report_foreign_exchange_summary: "report_foreign_exchange_summary",
    // report_foreign_exchange_detail: "report_foreign_exchange_detail",
    report_unrealised_exchange_detail: "report_unrealised_exchange_detail",
    report_exchange_rate: "report_exchange_rate",
    report_audit_trail: "report_audit_trail",
    report_chart_of_accounts: "report_chart_of_accounts",

    //Bukku Admin
    bukkuadmin_transaction_record: "bukkuadmin_transaction_record",
};
